<script setup lang="ts">
import useChatBot from '~/composables/useChatbot'
import Chatbot from '~/components/chat/Chatbot.vue'

const props = defineProps<{ locationId: number, prompt: string }>()

const {
  bot,
  promptOptions: options,
  isLoading,
  isError,
  isStreaming,
  chatHistory,
  prompt,
  isInteracting
} = useChatBot({ locationId: props.locationId })
</script>

<template>
  <Chatbot
    class="my-8 w-full rounded-xl bg-[--theme-10,#ffead1ff] p-6 font-inter text-base"
    v-bind="{ bot, options, isLoading, isError, isStreaming, chatHistory, prompt, autoFocus: false, isInteracting }"
  />
</template>
